module.exports = __webpack_public_path__ + "img/service.7dcd11dc.png";